export default function CustomOptionBox({ children, isActive, clickHandle, isSingleSelect }) {
    return (
        <>
            <div className={`${isActive ? "block" : "hidden"} w-screen h-screen fixed top-0 left-0`}
                onClick={clickHandle}
            ></div>
            <div className={`${isActive ? "scale-100" : "scale-0"} ${isSingleSelect ? "px-0 py-2" : ""} transition-all duration-300 ease-in-out bg-white z-20 absolute left-0 top-11 w-[706px] p-2 rounded-lg border-2 border-solid border-gray-400 mx-auto shadow-lg cursor-default`}
                onClick={e => e.stopPropagation()}
            >
                {children}
            </div>
        </>
    )
}